// extracted by mini-css-extract-plugin
export default {"leads":"Leads_leads__d6DHq","reportStatuses":"Leads_reportStatuses__urynx","actions":"Leads_actions__M47JQ"};